const adminDashboard = {
  newRequestRoute: {
    invalidProjectId: "Invalid project ID",
  },
  usersView: {
    loading: "Loading users...",
    heading: "User Management",
    totalUsers: "Total Users: {{count}}",
    noUsersFound: "No users found",
    sections: {
      allOrgUsers: "All Organization Users",
      yourProjectUsers: "Users in Your Projects",
      otherOrgUsers: "Other Organization Users",
    },
    errors: {
      loadFailed: "Failed to load data",
      disable2faFailed: "Failed to disable 2FA",
      promotePiFailed: "Failed to promote user to PI",
      revokePiFailed: "Failed to revoke PI status",
      addToProjectFailed: "Failed to add user to project",
      removeFromProjectFailed: "Failed to remove user from project",
    },
    success: {
      disable2fa:
        "2FA disabled successfully. User will be required to set up 2FA on next login.",
      promotePi: "User promoted to PI.",
      revokePi:
        "PI status revoked. User demoted to Researcher and removed as PI from their active projects.",
      addToProject: "User added to project successfully.",
      removeFromProject: "User removed from project successfully.",
    },
  },
  projectsView: {
    loading: "Loading projects...",
    loadFailed: "Failed to load projects",
    heading: "Project management",
    projectCount_one: "{{count}} project",
    projectCount_other: "{{count}} projects",
    archivedSuffix_one: ", {{count}} archived",
    archivedSuffix_other: ", {{count}} archived",
    showArchived: "Show archived",
    newProject: "New project",
    noProjectsArchived: "No projects yet",
    noProjectsActive:
      "No active projects — tick “Show archived” if you are looking for a retired one",
    owner: "Owner",
    status: {
      archived: "Archived",
      active: "Active",
      inactive: "Inactive",
    },
  },
  requestsView: {
    loading: "Loading data requests...",
    loadFailed: "Failed to load data requests",
    heading: "Requests to review",
    subtitle: "Data requests and dataset access requests in projects you manage.",
    ownRequestsBefore: "Your own requests are under ",
    ownRequestsLink: "Your requests",
    ownRequestsAfter: ".",
    newRequest: "+ New Request",
    noRequestsFound: "No requests are waiting for you.",
  },
};

export default adminDashboard;
